import React from 'react';
import { passwordStrength, STRENGTH_LABELS } from '../services/passwordStrength';

const COLORS = ['rgba(238,242,255,0.12)', '#ff4d4d', '#f59e0b', '#a3e635', '#C8F135'];

// Jauge de robustesse affichée sous le champ « mot de passe » à la création
export default function PasswordStrength({ password }) {
  if (!password) return null;
  const { level, checks, common } = passwordStrength(password);
  return (
    <div style={{ margin: '-4px 0 6px' }} aria-live="polite">
      <div style={{ display: 'flex', gap: 4 }}>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} style={{ flex: 1, height: 4, borderRadius: 2, background: i <= level ? COLORS[level] : COLORS[0], transition: 'background .2s' }} />
        ))}
      </div>
      <p style={{ margin: '6px 0 6px', fontSize: '0.75rem', color: COLORS[level], fontWeight: 600 }}>
        Robustesse : {STRENGTH_LABELS[level]}
      </p>
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 3 }}>
        {checks.map((c) => (
          <li key={c.id} style={{ fontSize: '0.74rem', color: c.ok ? 'rgba(238,242,255,0.75)' : 'rgba(238,242,255,0.38)', display: 'flex', gap: 6 }}>
            <span style={{ color: c.ok ? '#C8F135' : 'rgba(238,242,255,0.25)', width: 12 }}>{c.ok ? '✓' : '○'}</span>{c.label}
          </li>
        ))}
        {common && (
          <li style={{ fontSize: '0.74rem', color: '#ff4d4d', display: 'flex', gap: 6 }}>
            <span style={{ width: 12 }}>!</span>Évitez les mots trop courants (azerty, 123456, nowatt…)
          </li>
        )}
      </ul>
    </div>
  );
}
